import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { MegacablePlan, MegacablePlansResult } from '../models/megacable-plan.model';

@Injectable({
  providedIn: 'root'
})
export class MegacableService {

  private readonly _plansUrl = `${environment.API_SECURITY}/Megacable/plans`;
  private _plansCache$?: Observable<MegacablePlansResult>;

  constructor(private readonly _http: HttpClient) {}

  getPlans(): Observable<MegacablePlansResult> {
    if (!this._plansCache$) {
      this._plansCache$ = this._http.get<MegacablePlan[]>(this._plansUrl).pipe(
        map((response) => ({
          plans: this._normalizePlans(response),
          unavailable: false
        })),
        catchError((error) =>
          of({
            plans: [],
            unavailable: error?.status === 503
          })
        ),
        shareReplay(1)
      );
    }
    return this._plansCache$;
  }

  private _normalizePlans(response: MegacablePlan[] | null | undefined): MegacablePlan[] {
    if (!Array.isArray(response)) {
      return [];
    }

    return response
      .filter((item) => !!item?.planId?.trim())
      .map((item) => ({
        planId: `${item.planId}`.trim(),
        name: `${item.name ?? ''}`.trim(),
        description: `${item.description ?? ''}`.trim(),
        monthlyPrice: Number(item.monthlyPrice),
        simType: `${item.simType ?? ''}`.trim()
      }))
      .filter((item) => Number.isFinite(item.monthlyPrice));
  }
}
